export const fbConfig = {
	apiKey: 'AIzaSyCJiV_Y5zjr3nR4OiGE7vWkFCw6DZ1NfyA',
	authDomain: 'my-website-b71e9.firebaseapp.com',
	databaseURL: 'https://my-website-b71e9.firebaseio.com',
	projectId: 'my-website-b71e9',
	storageBucket: 'my-website-b71e9.appspot.com',
	messagingSenderId: '777205553748',
	appId: '1:777205553748:web:f3d34138cb0db8d1256bc1',
	measurementId: 'G-NQG7SN82YS'
};